// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---CzF6a","changedRecordsList":"changedRecordsList---wiAAo","changedRecord":"changedRecord---o4mHY"};